import { Dictionary } from './dictionary';
//dictionary with languages available in PatientPACE
export const applicationLanguages: Dictionary<string>[] = [
    { value: 'en', viewValue: 'English' },
    // { value: 'pl', viewValue: 'Polski' },
];

export const languageTranslationFilesDictionary = {
    en: ['./assets/i18n/en.json'],
    // pl: ['./assets/i18n/pl.json'],
};
